var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/fullscreen.53d64f4e.png","uri@2x": __webpack_public_path__ + "static/media/fullscreen.9180fc94.png","uri@3x": __webpack_public_path__ + "static/media/fullscreen.bbf68a53.png",
    width: 24,
    height: 24
});